// extracted by mini-css-extract-plugin
module.exports = {"container":"Tags_container___m_I_"};